import React from "react";
import Navbar from "../components/Navbar.js";
import Hero from "../components/lp/Hero.js";
import Sect1 from "../components/lp/Sect1.js";
import PopSubjSect from "../components/PopSubjSect.js";
import Sect3 from "../components/lp/Sect3.js";
import Sect4 from "../components/lp/Sect4.js";
import TrackProgSect from "../components/TrackProgSect.js";
import Aside from "../components/AsideSection.js";
import Footer from "../components/Footer.js";

const LandingPage = () => {
  return (
    <div className="lp">
      {/* TODAY */}
      <Navbar />
      <header>
        <Hero />
      </header>
      <main>
        <Sect1 />
        <PopSubjSect />
        <Sect3 />
        <Sect4 />
        <TrackProgSect />
      </main>
      <aside>
        <Aside />
      </aside>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default LandingPage;
